import { JourneyDataType } from "../@types/travel";

const getTotalDistance = (journeysData: JourneyDataType[]) => {
  // Calculated from `distance` field since only journey with `flight` type has distanceCovered inside `estimate` 
  const totalDistance = journeysData?.reduce((a, b) => {
    return b?.distance?.value ? a + b?.distance?.value : a
  }, 0);

  const unit = journeysData[0]?.estimate?.distanceUnit || journeysData[0]?.distance?.unit;

  if (!totalDistance || !unit) {
    return '';
  }
  
  return `${Math.round(totalDistance)?.toLocaleString()} ${unit?.toLowerCase()}`
}

const getTotalCo2Emissions = (journeysData: JourneyDataType[]) => {
  const distance = journeysData?.reduce((a, b) => a + b?.estimate?.co2eQuantity, 0);
  const unit = journeysData[0]?.estimate?.co2eQuantityUnit

  if (!distance || !unit) {
    return;
  }

  return `${Math.round(distance)?.toLocaleString()} ${unit?.toLowerCase()}`
}

export {
  getTotalDistance,
  getTotalCo2Emissions,
}